import collapse from './modules/collapse';
import menu from './modules/menu';
import scrollTop from './modules/scrollTop';
import swiper from './modules/swiper';

collapse();
menu();
scrollTop();
swiper();
